interface PageHeaderProps {
  title: string;
  subtitle: string;
  image: string;
}

export default function PageHeader({ title, subtitle, image }: PageHeaderProps) {
  return (
    <section className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden">
      <img
        src={image}
        alt={title}
        title={`${title} — Humanity59`}
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight">
          {title}
        </h1>
        <p className="mt-4 text-base md:text-lg text-background-50/90 max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      </div>
    </section>
  );
}